import { createSelector } from 'reselect';
import { RootState } from 'src/store/storeManager';

const getSceneDataLinks = (state: RootState) => state.sceneConfiguration.dataLinks;

const getLinksData = createSelector([getSceneDataLinks], (links) => links);

export default getLinksData;
